import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconPersonRemove(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M10 8c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4ZM6 18c0-2.66 5.33-4 8-4s8 1.34 8 4v2H6v-2Zm-4-8a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H2Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
